import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7d0fdaad&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7d0fdaad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0fdaad",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppTestimonials: require('/opt/build/repo/components/blocks/AppTestimonials.vue').default,AppFeatures: require('/opt/build/repo/components/AppFeatures.vue').default,AppPricing: require('/opt/build/repo/components/AppPricing.vue').default,CallToAction: require('/opt/build/repo/components/elements/CallToAction.vue').default})
